import {Component, Input, OnInit} from "@angular/core";
import {EPushNotificationReminderType} from "../../../../dto/reminder-type";
import {PaymentEmailReminderType} from "../../../../dto/payment-email-reminder-type";
import {EmailReminderTypeService} from "../../../../services/email-reminder-type.service";
import {PushNotificationTemplate} from "../../../../dto/templates/html-template";
import {PushNotificationReminderType} from "../../../../dto/push-notification-reminder-type";
import {PushNotificationReminderTypeService} from "../../../../services/push-notification-reminder-type.service";

@Component({
  selector: 'app-push-notification-reminder-types',
  templateUrl: './push-notification-reminder-types.component.html',
  styleUrls: ['./push-notification-reminder-types.component.css']
})
export class PushNotificationReminderTypesComponent implements OnInit {

  @Input() pushNotificationTemplates: PushNotificationTemplate[];
  @Input() reminderType: EPushNotificationReminderType;
  @Input() caption: string;
  @Input() description: string;

  reminderTypes: PushNotificationReminderType[];
  isLoading: boolean;

  constructor(
    private reminderTypeService: PushNotificationReminderTypeService,
  ) { }

  ngOnInit() {
    this.loadReminderTypes();
  }

  loadReminderTypes() {
    console.log("load reminder types");
    this.isLoading = true;
    this.reminderTypeService.getReminderTypes(this.reminderType).subscribe(result => {
      this.reminderTypes = result.data;
      this.isLoading = false;

    });
  }

  addReminderType() {
    const maxOrder = Math.max(0, ...this.reminderTypes.map(value => value.order));
    const item = { order: maxOrder + 1, dayOffset: 1, type: this.reminderType } as PushNotificationReminderType;
    this.reminderTypes.push(item);
  }


}
